import React from 'react';
import { motion } from 'framer-motion';

export default function Account() {
  return (
    <div className="min-h-screen section-padding bg-soft-ivory" data-testid="account-page">
      <div className="max-w-4xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center mb-16 space-y-4"
        >
          <h1 className="heading-1">My Ritual</h1>
          <p className="body-text text-dark-cedar/70">Manage your wellness journey</p>
        </motion.div>

        <div className="space-y-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.1 }}
            className="card-flat p-8"
          >
            <h2 className="heading-3 mb-6">Order History</h2>
            <p className="text-dark-cedar/60">Your past orders will appear here.</p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
            className="card-flat p-8"
          >
            <h2 className="heading-3 mb-6">Saved Rituals</h2>
            <p className="text-dark-cedar/60">Your favorite tea rituals will be saved here.</p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3 }}
            className="card-flat p-8"
          >
            <h2 className="heading-3 mb-6">Profile Settings</h2>
            <p className="text-dark-cedar/60">Manage your account details and preferences.</p>
          </motion.div>
        </div>
      </div>
    </div>
  );
}